import { Component, Vue } from 'vue-property-decorator';
import { UserProfile, SystemStatusType } from '@/types';
import appStore from '@/store/app';
import ordersStore from '@/store/orders';
import authenticator from '@/store/authentication';
import NavBarMenu from '@/components/NavBarMenu';
import UserAvatar from '@/components/UserAvatar';
import BannersBar from '@/components/BannersBar';
import { ApplicationConfiguration } from '@/types';
import ChangePassword from '@/components/ChangePassword';
import RequestResetPassword from '@/components/RequestResetPassword';

@Component({
    components: { NavBarMenu, UserAvatar, BannersBar },
})
export default class NavBar extends Vue {

    private isMenuNavBarActive = false;

    private get menuNavBarToggleIcon(): string {
        return this.isMenuNavBarActive ? 'times' : 'ellipsis-v';
    }

    private get menuToggleMobileIcon(): string {
        return this.isAsideMobileExpanded ? 'chevron-left' : 'bars';
    }

    private get darkModeToggleIcon(): string {
        return this.isDarkMode ? 'sun' : 'moon';
    }

    private get isNavBarVisible(): boolean {
        return appStore.isNavBarVisible;
    }

    private get isAsideMobileExpanded(): boolean {
        return appStore.isAsideMobileExpanded;
    }

    private get isDarkMode(): boolean {
        return appStore.isDarkMode;
    }

    private get user(): UserProfile {
        if (authenticator.isLoggedIn) {
            return authenticator.userProfile;
        } else {
            return { name: 'Utente', given_name : 'Utente', family_name: '' } as UserProfile;
        }
    }

    private get isUserLoggedIn(): boolean {
        return authenticator.isLoggedIn;
    }

    private get configuration(): ApplicationConfiguration {
        return appStore.applicationConfiguration;
    }

    private get systemAvailabilityIcon(): string {
        return appStore.systemStatus.status === SystemStatusType.Available ? 'is-success' : 'is-danger';
    }

    private get cartCount(): number {
       return ordersStore.cartCount;
    }

    private get cartIsUpdated(): boolean {
        return ordersStore.isCartUpdate;
    }

    private menuToggleMobile(): void {
        appStore.toggleMenuMobile(undefined);
    }

    private menuNavBarToggle(): void {
        this.isMenuNavBarActive = (!this.isMenuNavBarActive);
    }

    private darkModeToggle(): void {
        appStore.setDarkMode();
    }

    private async login() {
        await authenticator.startSignInAsync();
    }

    private async logout() {

        this.$buefy.dialog.confirm({
            title: 'Termina sessione',
            message: 'Sei sicuro/a di voler <b>chiudere</b> la sessione corrente ?',
            confirmText: 'Conferma',
            cancelText: 'Annulla',
            type: 'is-info',
            hasIcon: true,
            onConfirm: async () => {
                await this.logoutAsync();
            },
        });
    }

    private async logoutAsync() {
        authenticator.signOutAsync()
            .then((result) => {
                this.$buefy.snackbar.open({
                    message: 'Sessione terminata.',
                    queue: false,
                });
            });
    }

    private async changePassword() {

        if (!this.isUserLoggedIn) { return; }

        this.$buefy.modal.open({
            parent: this,
            component: ChangePassword,
            hasModalCard: true,
        });
    }

    private async ResetPassword() {
        this.$buefy.modal.open({
            parent: this,
            component: RequestResetPassword,
            hasModalCard: true,
        });
    }
}
